// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"blocks/key-topical-issues/view": 0,
	"blocks/key-topical-issues/style-view": 0
};

var installChunk = (data) => {
	var {__webpack_esm_ids__, __webpack_esm_modules__, __webpack_esm_runtime__} = data;
	// add "modules" to the modules object,
	// then flag all "ids" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	for(moduleId in __webpack_esm_modules__) {
		if(__webpack_require__.o(__webpack_esm_modules__, moduleId)) {
			__webpack_require__.m[moduleId] = __webpack_esm_modules__[moduleId];
		}
	}
	if(__webpack_esm_runtime__) __webpack_esm_runtime__(__webpack_require__);
	for(;i < __webpack_esm_ids__.length; i++) {
		chunkId = __webpack_esm_ids__[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[__webpack_esm_ids__[i]] = 0;
	}
	__webpack_require__.O();
}

// no chunk on demand loading

// no prefetching

// no preloaded

__webpack_require__.C = installChunk;

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
// no HMR

// no HMR manifest